import { toast } from '@croquiscom-pvt/zds';

import { isIOS } from '@common/device-manager';

const KEYBOARD_THRESHOLD = 100; // 키보드 등장으로 간주할 뷰포트 높이 변화 임계값 (px)

// 옵션에서는 기본 설정된 offsetBottom이 아닌 40px로 노출되도록 설정
// iOS에서 키보드가 올라온 경우 키보드 높이만큼 추가로 올림
export const showZDSToastInOption = (content: string, offsetBottom: number = 40) => {
  let adjustedOffsetBottom = offsetBottom;

  // iOS에서만 키보드가 올라왔는지 체크
  if (typeof window !== 'undefined' && isIOS() && window.visualViewport) {
    const visualHeight = window.visualViewport.height;
    const layoutHeight = window.innerHeight;
    const keyboardHeight = Math.max(0, layoutHeight - visualHeight);

    // 키보드가 올라온 경우 (일정 threshold 이상 차이가 날 때만)
    if (keyboardHeight > KEYBOARD_THRESHOLD) {
      adjustedOffsetBottom = keyboardHeight;
    }
  }

  return toast({ content, offsetBottom: adjustedOffsetBottom });
};
